// import React, { useEffect, useState } from "react";
// import { DataTable } from "primereact/datatable";
// import { useNavigate } from "react-router-dom";
// import { Column } from "primereact/column";
// import { api } from "../../../../../utility/AxiosInceptor";
// import { NextIcon } from "../../../../../utility";

// export default function Searchall({ searchValue, callSearchApi, setSearchBy, setSearchByValueClick }) {
//     const navigate = useNavigate();
//     const [searchData, setSearchData] = useState([]);
//     const loginRes = localStorage.getItem("userData");
//     const parseLoginRes = JSON.parse(loginRes);
//     const roleName = parseLoginRes?.role?.role;
//     const toCapital = roleName.toUpperCase();

//     const data = localStorage.getItem("permissions");
//     const parseData = JSON.parse(data);
//     useEffect(() => {

//     }, [callSearchApi]);
import { api } from "../../../../../utility/AxiosInceptor";
import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { debounce } from "lodash";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";
import "./search_all.css";
import { NextIcon, PrevIcon, Postpaid } from "../../../../../utility";
import CommonLoaderBlue from "../../billingModel/billingmodel_configurations/Loaders/components/Loader/LoaderBlue";

const isButtonLoading = false;

const statusFiltersSelected = {
  prospectchecked: false,
  cancelchecked: false,
  all: false,
};

export default function Searchall({
  searchValue,
  callSearchApi,
  setSearchBy,
  setSearchByValueClick,
}) {
  const navigate = useNavigate();

  const handleEnrollmentIdClick = (rowData) => {
    setSearchByValueClick(false);
    setSearchBy(null);
    navigate("/customer-profile", { state: { selectedId: rowData._id } });
    localStorage.setItem("selectedId", JSON.stringify(rowData._id));
  };

  const [overlayContent, setOverlayContent] = useState("");
  const statusOverlayRef = useRef(null);
  const [isFirstTimeCalledApi, setIsFirstTimeCalledApi] = useState(false);

  const currentPagination = {};
  const [floatPagesLeft, setFloatPagesLeft] = useState([]);
  const [floatPagesRight, setFloatPagesRight] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [allEnrollments, setAllEnrollments] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const customerSearchName = "";
  const selectedRange = [null, null];

  const userData = JSON.parse(localStorage.getItem("userData"));
  const role = userData?.role?.role;

  const parseLoginRes = JSON.parse(localStorage.getItem("userData"));
  const [currentPage, setCurrentPage] = useState(1);

  /* ================= RESET PAGE (UNCHANGED) ================= */
  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerSearchName, statusFiltersSelected, selectedRange]);

  /* ================= FIXED DEBOUNCE ================= */

  const debouncedGetAllEnrollmentsRef = useRef(null);

  if (!debouncedGetAllEnrollmentsRef.current) {
    debouncedGetAllEnrollmentsRef.current = debounce(async () => {
      setIsLoading(true);
      setAllEnrollments([]);

      try {
        const permissions = JSON.parse(
          localStorage.getItem("permissions") || "[]"
        );

        const response = await api.post(
          `/api/web/search/?query=${searchValue}&userId=${parseLoginRes._id}`,
          { permissions }
        );

        let data = response?.data?.data;

        if (data && !Array.isArray(data)) {
          data = [data];
        }

        const updatedData = (data || []).map((item) => ({
          ...item,
          enrollment: item.isSelfEnrollment ? "Self Enrollments" : "Enrollment",
          name: `${item?.firstName ? item.firstName.toUpperCase() : ""} ${
            item?.lastName ? item.lastName.toUpperCase() : ""
          }`,
          createdDate: new Date(item.createdAt)
            .toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
            })
            .replace(/\//g, "-"),
          createdTo: item.createdAt,
        }));

        setAllEnrollments(updatedData);
        setIsFirstTimeCalledApi(true);
      } catch (err) {
        setAllEnrollments([]);
      } finally {
        setIsLoading(false);
      }
    }, 500);
  }

  /* ================= API CALL ================= */
  useEffect(() => {
    if (!parseLoginRes?._id) return;

    debouncedGetAllEnrollmentsRef.current();

    return () => {
      debouncedGetAllEnrollmentsRef.current.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, callSearchApi, currentPage]);

  /* ================= UI (UNCHANGED) ================= */

  return (
    <div className="prepaidall">
      <ToastContainer className="custom-toast-container" />

      <div className="flex w-full flex-column justify-content-start h-4">
        <div className="prepaidsimslogo">
          <span>
            <Postpaid />
          </span>
          <h6>Enrollment Lookup</h6>
        </div>
        <h3 className="heading" style={{ marginTop: ".6rem" }}>
          Enrollment Records
        </h3>
        <p className="para" style={{ marginTop: "1.2rem" }}>
          Explore enrollment records from across the system, filtered by your
          search criteria.
        </p>
      </div>

      <div
        className={
          role === "Admin" ? "allenrollmenttableadmin" : "allenrollmenttable"
        }
        style={{ marginTop: "2.4rem" }}
      >
        {isButtonLoading ? (
          <ProgressSpinner className="flex flex-wrap justify-content-center flex-row mt-4" />
        ) : null}

        <DataTable
          value={allEnrollments}
          selection={selectedRows}
          onSelectionChange={
            role !== "Admin" ? null : (e) => setSelectedRows(e.value)
          }
          size="small"
          stripedRows
          emptyMessage={
            isLoading ? (
              <div
                style={{ width: "108.4rem" }}
                className="flex p-2 flex-wrap flex-row justify-content-center align-items-center "
              >
                <CommonLoaderBlue customSize={14} />
              </div>
            ) : (
              ""
            )
          }
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          onRowClick={(e) => handleEnrollmentIdClick(e.data)}
          style={{ fontFamily: "Inter", fontSize: "14.4rem" }}
        >
          <Column
            selectionMode="multiple"
            style={{
              pointerEvents: role !== "Admin" ? "none" : "auto",
              opacity: role !== "Admin" ? 0.5 : 1,
            }}
          />
          <Column header="Id" field="enrollmentId"></Column>
          <Column
            header="Link Acc"
            body={(rowData) => {
              return (
                <p className={rowData?.linkedAccount ? "yes" : "no"}>
                  {rowData?.linkedAccount ? "Yes" : "No"}
                </p>
              );
            }}
          />
          <Column header="Name" field="name"></Column>
          <Column field="contact" header="Contact" />
          <Column
            header="Status"
            field="status"
            body={(rowData) => (
              <span
                style={{
                  color:
                    rowData?.status === "prospect"
                      ? "#4A90E2"
                      : rowData?.status === "cancelled"
                        ? "#95A5A6"
                        : rowData?.status === "active"
                          ? "#27AE60"
                          : rowData?.status === "disconnected"
                            ? "#B3261E"
                            : rowData?.status === "inactive"
                              ? "#B3261E"
                              : rowData?.status === "suspended"
                                ? "#F39C12"
                                : "",
                  fontSize: "1.4rem",
                  textTransform: "capitalize",
                }}
              >
                {rowData?.status}
              </span>
            )}
          />
          {role === "Admin" && (
            <Column
              field="createdBy.name"
              header="Created By"
              body={(rowData) => (
                <>
                  <p
                    onMouseEnter={(e) => {
                      if (rowData?.createdBy?.name?.length > 11) {
                        setOverlayContent(rowData?.createdBy?.name);
                        statusOverlayRef.current.show(e);
                      }
                    }}
                    onMouseLeave={() => statusOverlayRef.current.hide()}
                  >
                    {rowData?.createdBy?.name?.length > 11
                      ? rowData?.createdBy?.name?.substring(0, 8) + "..."
                      : rowData.createdBy?.name?.length === 0
                        ? "NIL"
                        : rowData?.createdBy?.name}
                  </p>
                  <OverlayPanel ref={statusOverlayRef}>
                    <div style={{ padding: "0.5rem 1rem" }}>
                      <p
                        style={{
                          fontWeight: 400,
                          fontSize: "1.4rem",
                          overflow: "hidden",
                          border: "none",
                          margin: "0rem",
                          lineHeight: "1.8rem",
                          color: "#72728f",
                        }}
                      >
                        {" "}
                        {overlayContent}
                      </p>
                    </div>
                  </OverlayPanel>
                </>
              )}
            />
          )}
          <Column field="createdDate" header="Date" />
        </DataTable>
        <div
          style={{ marginTop: "2.4rem" }}
          className="flex flex-wrap w-full  flex-row justify-content-between align-items-center "
        >
          {/* {isFirstTimeCalledApi && (
                               <h1 className="infoenrollmentsall">
                                   {currentPagination?.total ? (currentPagination?.page * currentPagination.limit > currentPagination.total ? currentPagination.total : currentPagination?.page * currentPagination.limit) : "0"}/{currentPagination?.total ? currentPagination?.total : "0"}
                               </h1>
                           )} */}
          {currentPagination?.totalPages > 1 && isFirstTimeCalledApi && (
            <div className="flex  flex-wrap flex-row justify-content-between pages">
              <button
                disabled={currentPage === 1}
                onClick={() => {
                  let pagetocheck = currentPage;
                  pagetocheck--;
                  if (currentPagination.totalPages <= 6 && pagetocheck > 0) {
                    setCurrentPage(pagetocheck);
                  } else if (
                    floatPagesLeft.includes(pagetocheck) ||
                    floatPagesRight.includes(pagetocheck)
                  ) {
                    setCurrentPage(pagetocheck);
                  } else if (pagetocheck > 0) {
                    if (pagetocheck === floatPagesLeft[0] - 1) {
                      let arr = floatPagesLeft;

                      arr.pop();
                      arr.unshift(floatPagesLeft[0] - 1);
                      setFloatPagesLeft(arr);
                      setCurrentPage(pagetocheck);
                    } else if (pagetocheck === floatPagesRight[0] - 1) {
                      let arr = floatPagesRight;

                      arr.pop();
                      arr.unshift(floatPagesRight[0] - 1);
                      setFloatPagesRight(arr);
                      setCurrentPage(pagetocheck);
                    }
                  }
                }}
                className="cursor-pointer backbtn"
                style={{
                  opacity: currentPage === 1 && "0.6",
                  backgroundColor: "#FFFFFF33",
                  width: "10.6rem",
                  height: "3.8rem",
                  margin: "0rem",
                }}
              >
                <span>
                  <PrevIcon /> &nbsp; Previous
                </span>
              </button>
              <div
                style={{ maxWidth: "26.9rem", gap: "1rem" }}
                className="flex flex-wrap flex-row justify-content-start align-items-start"
              >
                {currentPagination.totalPages <= 6 ? (
                  [...Array(currentPagination.totalPages)].map((_, index) => (
                    <Button
                      onClick={() => {
                        setCurrentPage(index + 1);
                      }}
                      style={{ width: "3.1rem", height: "3.4rem" }}
                      key={index + 1}
                      className={
                        Number(currentPagination.page) === index + 1
                          ? "pagecounteractive"
                          : "pagecounter"
                      }
                      label={index + 1}
                    />
                  ))
                ) : (
                  <>
                    {floatPagesLeft.map((page) => (
                      <Button
                        key={page}
                        onClick={() => {
                          setCurrentPage(page);
                        }}
                        style={{ width: "3.1rem", height: "3.4rem" }}
                        className={
                          currentPagination.page === page
                            ? "pagecounteractive"
                            : "pagecounter"
                        }
                        label={page}
                      />
                    ))}
                    {floatPagesLeft[floatPagesLeft.length - 1] + 1 !==
                      floatPagesRight[0] && (
                      <Button className="pagecounter" label={"..."} />
                    )}

                    {floatPagesRight.map((page) => (
                      <Button
                        onClick={() => {
                          setCurrentPage(page);
                        }}
                        key={page}
                        className={
                          currentPagination.page === page
                            ? "pagecounteractive"
                            : "pagecounter"
                        }
                        label={page}
                      />
                    ))}
                  </>
                )}
              </div>
              <button
                disabled={currentPage === currentPagination.totalPages}
                onClick={() => {
                  let pagetocheck = currentPage;
                  pagetocheck++;
                  if (
                    currentPagination.totalPages <= 6 &&
                    pagetocheck > 0 &&
                    pagetocheck <= currentPagination.totalPages
                  ) {
                    setCurrentPage(pagetocheck);
                  } else if (
                    floatPagesLeft.includes(pagetocheck) ||
                    floatPagesRight.includes(pagetocheck)
                  ) {
                    setCurrentPage(pagetocheck);
                  } else if (pagetocheck <= currentPagination.totalPages) {
                    if (
                      pagetocheck ===
                      floatPagesLeft[floatPagesLeft.length - 1] + 1
                    ) {
                      let arr = floatPagesLeft;

                      arr.shift();
                      arr.push(pagetocheck);
                      setFloatPagesLeft(arr);
                      setCurrentPage(pagetocheck);
                    } else {
                      if (
                        pagetocheck ===
                          floatPagesRight[floatPagesRight.length - 1] + 1 &&
                        pagetocheck <= currentPagination.totalPages
                      ) {
                        let arr = floatPagesRight;

                        arr.shift();
                        arr.push(pagetocheck);
                        setFloatPagesRight(arr);
                        setCurrentPage(pagetocheck);
                      }
                    }
                  }
                }}
                className="cursor-pointer backbtn"
                style={{
                  opacity:
                    currentPage === currentPagination.totalPages && "0.6",
                  backgroundColor: "#FFFFFF33",
                  width: "8rem",
                  height: "3.8rem",
                }}
              >
                <span className="flex align-items-center">
                  Next &nbsp;
                  <NextIcon />
                </span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
